import React from 'react'
import { Text } from '@fluentui/react-components'
import { formatToSwedishCrowns } from '../../helpers/stringHelper'
import { t } from '../../i18n/i18n'

type FormattedMoneyOutputProps = {
   value: number
   size?: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | 1000
}

export const FormattedMoneyOutput = ({ value, size = 400 }: FormattedMoneyOutputProps) => {
   const formattedValue = formatToSwedishCrowns(value)
   if (!formattedValue)
      return (
         <Text italic size={size}>
            {t('NoValueSet')}
         </Text>
      )

   return <Text size={size}>{`${formattedValue} kr`}</Text>
}
